import cn from 'classnames'
import { white100 } from 'ext-ui/style/colors'
import React, { ComponentProps } from 'react'

type RejectedTransactionsIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function RejectedTransactionsIcon(
  props: RejectedTransactionsIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('RejectedTransactionsIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="black"
      />
      <g clipPath="url(#clip0_23209_68111)">
        <path
          d="M5.55566 11.6668C5.55566 11.6668 6.11122 11.1112 7.77789 11.1112C9.44455 11.1112 10.5557 12.2224 12.2223 12.2224C13.889 12.2224 14.4446 11.6668 14.4446 11.6668V5.00014C14.4446 5.00014 13.889 5.55569 12.2223 5.55569C10.5557 5.55569 9.44455 4.44458 7.77789 4.44458C6.11122 4.44458 5.55566 5.00014 5.55566 5.00014L5.55566 15.5557"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_23209_68111">
          <rect
            width="13.3333"
            height="13.3333"
            fill={white100}
            transform="translate(3.33301 3.33325)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
